import { render, staticRenderFns } from "./template.pug?vue&type=template&id=50dfe042&lang=pug&"
import script from "./script.ts?vue&type=script&lang=js&"
export * from "./script.ts?vue&type=script&lang=js&"
import style0 from "./style.sass?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports